/**
 * Created by Julio Perez on 7/11/2017.
 */
routes.$inject = ['$stateProvider'];

export default function routes($stateProvider){

    $stateProvider
        .state('scatterplot', {
            url: '/scatterplot',
            template: require('./index.html')
        })
}


// WEBPACK FOOTER //
// ./src/app/emxd-charts/scatterplot/scatterplot.route.js